export const themeLight = {
    typography: {
      fontFamily: ['Work Sans', 'Roboto'],
      h4: {
        fontWeight: 600,
      },
    },
    palette: {
      type: 'light',
      background: {
        default: '#fff',
      },
    },
  };
  
  export const themeDark = {
    typography: {
      fontFamily: ['Work Sans', 'Roboto'],
      h4: {
        fontWeight: 600,
      },
    },
    palette: {
      type: 'dark',
      background: {
        default: '#222',
      },
    },
  };
  